import { makeAutoObservable } from 'mobx';
import { LoginValidationError } from '../../../../../infrastructure/types/features/auth/auth-types';
import { validate } from '../../../../../../shared/logic/core-logic/validation/ValidationResult';
import { validationHelpers } from '../../../../../../shared/infrastructure/validation-rules/validation-helpers';
import { LoginManager } from '../managers/LoginManager';

class LoginValidator {
  constructor(private loginManager: LoginManager) {
    makeAutoObservable(this, {});
  }

  get login() {
    const value = this.loginManager.login;

    const result = validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      LoginValidationError.EMAIL_EMPTY,
    );

    return result.addCheckIfPreviousPassed(
      validationHelpers.emailCorrectFormat(value),
      LoginValidationError.EMAIL_INCORRECT,
    );
  }

  get password() {
    const value = this.loginManager.password;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      LoginValidationError.PASSWORD_EMPTY,
    );
  }

  get hasErrors() {
    return this.login.hasErrors || this.password.hasErrors;
  }
}

export { LoginValidator };
